<!-- 头部组件 -->
<template>
    <div
        id="md01"
        class="header-main">
        <div class="header-top">
            <div class="logo-main">
                <a href="/">
                    <img src="../assets/images/logo.png" alt="" class="logo" />
                </a>
            </div>
            <ul>
                <li
                    v-for="item in list"
                    :key="item.id">
                    <a
                        class="tab"
                        @click="goToScroll(item.id)"
                        >{{ item.name }}</a
                    >
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

export default {
    components: {

    },
    data () {
        return {
            list: [
                { id: '#md01', name: 'Inicio' },
                { id: '#md02', name: 'productos' },
                { id: '#md03', name: '¿Por qué elegirnos?' },
                { id: '#md04', name: 'Proceso de solicitud' },
                { id: '#md05', name: 'Preguntas frecuentes' },
                { id: '#md06', name: 'Calificación' },
                // {id:'declaration', name: 'Declaration of rights'},
                { id: 'AVISO', name: 'AVISO DE PRIVACIDAD' },
                { id: 'Condiciones', name: 'Términos y Condiciones' },
            ]
        }
    },
    created () {

    },
    mounted () {

    },
    methods: {
        goToScroll (values) {
            if (values === '#md01') {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
                return
            }
            if (values === 'declaration') {
                this.$router.push('/declaration')
                return
            }
            if (values === 'AVISO') {
                this.$router.push('/agreement')
                return
            }
            if (values === 'Condiciones') {
                this.$router.push('/condiciones')
                return
            }
            else {
                if (this.$route.name !== 'home') {
                    this.$router.push('/')
                }
                document.querySelector(values).scrollIntoView(true)
            }
        },
    }
}
</script>
<style  scoped>
/* @import '@/assets/css/style.css'; */
.header-main {
    width: 1200px;
    position: fixed;
    top: 15px;
    left: 0;
    right: 0;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    z-index: 3;

    background: #0b71ff;
    width: 100%;
    left: 0;
    top: 0;
    right: 0;
    padding: 10px 20px;
    box-sizing: border-box;
}

.logo {
    width: 72px;
}

.header-main ul {
    display: flex;
    align-items: center;
}

.header-main ul li {
    margin-left: 36px;
    color: #fff;
}

.tab {
    color: #fff;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue